<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";
import HandBand from "#/assets/icons/hand_band.svg";
import PayCard from "#/assets/icons/pay_card.svg";
import PayCash from "#/assets/icons/pay_cash.svg";
import PaySBP from "#/assets/icons/qr_scanner.svg";
import YandexBadge from "#/assets/icons/yandex_badge.svg";
import ArrowLeft from "#/assets/iconsDynamic/ArrowLeft.vue";
import { useCardStore } from "#/store/card";
import { useCartStore } from "#/store/cart";

const props = withDefaults(
	defineProps<{
		configPage: {
			kiosk_menu: boolean;
			qr_menu: boolean;
		};
		comment: string;
		cartItems: any[];
		orderId?: string | null;
		signal?: AbortSignal;
		provider: any;
	}>(),
	{
		orderId: null,
	},
);

const emit = defineEmits<{
	select: [providerId: string];
}>();

const storeCart = useCartStore();
const storeCard = useCardStore();
const { selectedProvider } = storeToRefs(storeCart);
const { isAddToCard } = storeToRefs(storeCard);

const imagesMap: Record<string, string> = {
	default: PayCard,
	SBP: PaySBP,
	CASH: PayCash,
	YANDEX_BADGE: YandexBadge,
	PAYMENT_TRACKER: HandBand,
};

const paymentCreateOrder = async () => {
	selectedProvider.value = props.provider;
	const providerId = props.provider.front_type;
	if (!providerId) return;

	isAddToCard.value = false;

	emit("select", props.provider.type);
};

const image = computed(() => imagesMap[props.provider.front_type] || imagesMap.default);
</script>:

<template>
	<div class="payment_boxes_wrapper" @click="paymentCreateOrder">
		<img class="picture" :src="image" alt="">
		<div class="header_description">
			<b>{{ provider.name }}</b>
			<p>{{ provider.description }}</p>
		</div>
		<ArrowLeft />
	</div>
</template>

<style lang="scss" scoped>
  @use './paymentBoxes.scss'
</style>
